import { Button, Col, Form, Modal, Space } from 'antd';
import React, { ReactElement, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormOTPInput } from '../../../../shared/components/crmFormElement/FormInput';
import { RootState } from '../../../../store';
import { setOTPModalVisible, verifyOTP } from '../../../../store/actions/reimbursementAction';
import { ApplicationDetailModel } from '../../../../store/models/applicationDetailModel';
import { centeredNotification } from '../../../../utils/utility';
import './OTPModal.less';

const OTPModal = ({ onOTPSuccessSubmit, form, OTPToken, dispatchOTP }: any): ReactElement => {
  const appdetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );
  const { isOTPModalVisible } = useSelector((state: RootState): any => state.reimbursement);
  const [counter, setCounter] = React.useState(30);
  const [disabled, setDisabled] = React.useState(true);
  const [otp, setOtp] = React.useState('');

  const dispatch = useDispatch();
  const onSuccess = (): any => {
    onOTPSuccessSubmit();
  };
  const onError = (errorMessage: any): any => {
    centeredNotification(errorMessage);
  };

  useEffect((): any  => {
    const timer = setInterval((): any => setCounter(counter - 1), 1000);
    if (counter <= 0 ) {
      clearInterval(timer);
      setDisabled(false);
    }
    return (): any => clearInterval(timer);
  });

  const verifyOtp = (): void => {
    const payload = {
      phoneNumber: (form.getFieldsValue()).mobile,
      providerId: appdetails.getProviderId(),
      encryptedToken: OTPToken,
      otp: {otp}?.otp,
    };
    {
      !(form.getFieldsValue()).otp || (form.getFieldsValue()).otp === '' ? centeredNotification('Please Enter the OTP')
      : dispatch(verifyOTP(payload, onSuccess, onError));
    }
  };

  const resendOtp = (): void => {
    setCounter(30);
    setDisabled(true);
    dispatchOTP();
  };

  const close = (): void => {
    dispatch(setOTPModalVisible(false));
  };
  return (
    <>
      <Modal  visible={isOTPModalVisible}
        onCancel={close}
        footer={null}
        className={'text-center'}
        maskClosable={false}>
        <Form
          form={form}
          onFinish={verifyOtp}>
          <Col>
              <p>We will be sending an OTP to your registered mobile no. to submit<br/> the claim on behalf of hospital.</p>
          </Col>
          <Col>
            <FormOTPInput
              onChangeOTP={setOtp}
              form={form}
              autoFocus={true}
              length={6}
              className="otpContainer"
              inputClassName="otpInput"/>
            <div
              className="resend-otp-container">
              {(counter > 0 ) && <p> Resend OTP in {counter} seconds</p>}
            </div>

          </Col>
          <Col className="text-right">
          <Space>
           <Button  disabled={disabled} onClick={resendOtp}> Resend OTP </Button>
            <Button className="btn-form-submit" onClick={verifyOtp}>
              Submit
            </Button>
            </Space>
          </Col>
        </Form>
      </Modal>
    </>
  );

};

export default OTPModal;
